<template>
    <section class="timelineCards">
        <timeline-card
            v-for="(teaser, key) in cards"
            :key="key"
            :data="teaser?.element"
        />
    </section>
</template>

<script setup>
import {computed, defineProps} from "vue";
import TimelineCard from "@/components/listings/timelineCard.vue";

const props = defineProps({
    data: [Object, Array],
});

const cards = computed(() => props.data?.[0]?.content ?? props.data?.content ?? []);
</script>
